enum HeatmapViewType {
    pinnedComments = 0,
    heatmap = 1
}

export default HeatmapViewType;